import { NETWORKING_LOUNGE_API_URL, APP_DOMAIN } from 'appenv';
import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { Table } from './types';

const getEventTableList = async () => {
  const tableResponse = await fetch(`${NETWORKING_LOUNGE_API_URL}/events/${APP_DOMAIN}/tables`);
  const { tables } = await tableResponse.json();
  return tables;
};

const tablesAdapter = createEntityAdapter<Table>();

export const {
  selectAll: selectAllTables,
} = tablesAdapter.getSelectors((state: any) => state.networkingLounge.tables);

export const fetchTables = createAsyncThunk(
  'tables/fetchAll',
  async () => {
    try {
      const result = await getEventTableList();
      return result;
    } catch (error) {
      console.error(error);
    }
    return {};
  },
);

export const tableSlice = createSlice({
  name: 'tables',
  initialState: tablesAdapter.getInitialState({
    fetching: false,
    fetchError: false,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTables.pending, (state: any) => {
      tablesAdapter.removeAll(state);
      state.fetching = true;
      state.fetchError = false;
    });
    builder.addCase(fetchTables.fulfilled, (state: any, action) => {
      state.fetching = false;
      if (!action.payload?.length) {
        state.fetchError = true;
      } else {
        tablesAdapter.upsertMany(state, action.payload);
      }
    });
    builder.addCase(fetchTables.rejected, (state: any) => {
      state.fetching = false;
      state.fetchError = true;
    });
  },
});

export default tableSlice.reducer;
